import { render, staticRenderFns } from "./PitCrewsRewards.vue?vue&type=template&id=ba99116e&scoped=true"
import script from "./PitCrewsRewards.vue?vue&type=script&lang=js"
export * from "./PitCrewsRewards.vue?vue&type=script&lang=js"
import style0 from "./PitCrewsRewards.vue?vue&type=style&index=0&id=ba99116e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba99116e",
  null
  
)

export default component.exports